// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

const toolbar = ['bold italic underline strikethrough alignleft aligncenter alignright outdent indent undo redo removeformat subscript superscript hr bullist numlist link image media charmap preview emoticons forecolor table fontsizeselect fontselect']

export default toolbar
